import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5","key":"svg-0"}],["path",{"d":"M19 16v6","key":"svg-1"}],["path",{"d":"M22 19l-3 3l-3 -3","key":"svg-2"}],["path",{"d":"M3 7l9 6l9 -6","key":"svg-3"}]]

const IconMailDown = createReactComponent('outline', 'mail-down', 'MailDown', __iconNode);

export default IconMailDown;